
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertTriggerGoogle as ObiAlertTriggerGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alert-trigger-google.js';
 
 
 

 
 export const ObiAlertTriggerGoogle = createComponent({
   react: React,
   tagName: 'obi-alert-trigger-google',
   elementClass: ObiAlertTriggerGoogleElement,
   events: {
     
   }
  });
 
 